import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { styleBlock } from "../styleBlock";
export default class StepperRequest extends React.PureComponent {
    render() {
        const { stepCompleted, steps, className } = this.props;
        const classNames = styleBlock("stepperrequest");
        const cn = classNames({}).mix([className]);
        const hasAnyNotes = steps.find(item => item.note);
        return (React.createElement("div", { className: cn.toString() },
            React.createElement(Row, { noGutters: true, className: "justify-content-start justify-content-md-center flex-md-nowrap" }, steps.map((curstep, index) => {
                const isStepPassed = stepCompleted >= index + 1;
                const isLastPassedStep = stepCompleted === index + 1;
                const isFirstIncompleteStep = stepCompleted === index && index !== 0;
                return (React.createElement(Col, { xs: "auto", key: `step-${index}`, className: "step" + (isStepPassed ? " step-passed" : "") + (hasAnyNotes ? " mt-md-3" : "") },
                    React.createElement("span", { className: "d-flex align-items-center" },
                        isFirstIncompleteStep && React.createElement("span", { className: "first-incomplete-step" }),
                        React.createElement("span", { className: "step-circle" + (isLastPassedStep ? " last-passed-step" : "") },
                            React.createElement("span", { className: "step-value" }, index + 1))),
                    React.createElement("span", { className: "step-name" }, curstep.title),
                    React.createElement("span", { className: "step-note text-muted" }, curstep.note)));
            }))));
    }
}
//# sourceMappingURL=index.js.map